import { sendRequest } from 'js-api'

export default {
  test: () => sendRequest('POST', 'member/api/notifications/test')
}
